import ReactApexChart from 'react-apexcharts'
import { useParams } from 'react-router-dom'
import { useStatsSingleProject } from '../../../hooks/useStatsSingleProject'
import { Alert } from 'antd'

export function AdSpendLine() {
  const { projectId } = useParams() as { projectId: string }
  const { facebookCampaignsInsights, projectAnalytics } = useStatsSingleProject(projectId)

  const adSpend = facebookCampaignsInsights.reduce((acc, campaign) => {
    return acc + Number(campaign.spend)
  }, 0)

  const budget = projectAnalytics?.adBudget ?? 1

  const budgetUsedPercentage = Math.round((adSpend / budget) * 100)

  const adSpendIn1000s = Math.round(adSpend / 1000)
  const adSpendBudgetIn1000s = Math.round(budget / 1000)

  const state = {
    series: [
      {
        name: 'Ad Spend',
        data: [budgetUsedPercentage],
      },
    ],
    options: {
      chart: {
        height: 50,
        type: 'bar',
        stacked: true,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '20%',
          colors: {
            backgroundBarColors: ['#40475D'],
          },
        },
      },
      stroke: {
        width: 0,
      },
      title: {
        floating: true,
        offsetX: -10,
        offsetY: 5,
        text: 'Ad Spend',
      },
      subtitle: {
        floating: true,
        align: 'right',
        offsetY: 0,
        text: `${budgetUsedPercentage}% (${adSpendIn1000s}/${adSpendBudgetIn1000s} tkr.)`,
        style: {
          fontSize: '20px',
        },
      },
      tooltip: {
        enabled: false,
      },
      xaxis: {
        categories: ['Ad Spend'],
      },
      yaxis: {
        max: 100,
      },
      fill: {
        opacity: 1,
      },
    },
  }

  return (
    <div>
      <div>
        {/*@ts-ignore */}
        <ReactApexChart options={state.options} series={state.series} type="bar" height={50} />
        {!projectAnalytics?.adBudget && <Alert type="warning" message="No budget set in admin module!" />}
      </div>
      <div id="html-dist-adspendchart"></div>
    </div>
  )
}
